export default __webpack_public_path__ + "df891e228f93d4bf850386971dbe38f8.png";